/**
 * Nombres de marca — TODOS vienen de env de build (`REACT_APP_*`, horneadas por CRA),
 * SIN default: si falta alguna, la app aborta al cargar (cero fallback silencioso, igual
 * que el backend con `_require`). Cada cuenta las define en su .env / SSM param `backoffice`
 * (dev: BRAND_NAME=Doer, SPONSOR=Luzu TV; prod: BRAND_NAME=Drupi, SPONSOR=Luzu TV). El script
 * post-build `scripts/template-public-html.js` usa las MISMAS vars para terms/privacy.
 */
function requireEnv(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`[brand] Falta la env var de build ${name} — definila en el .env (REACT_APP_*).`);
  }
  return value;
}

/**
 * BRAND_NAME — nombre de la app/producto. Se muestra en el logo, el <title> de la pestaña,
 * el nombre abajo-izquierda del footer, los textos de "cómo funciona" y en terms/privacy
 * (vía {{BRAND_NAME}}). Es el ÚNICO nombre de app.
 */
export const BRAND_NAME = requireEnv('REACT_APP_BRAND_NAME', process.env.REACT_APP_BRAND_NAME);

/**
 * SPONSOR_NAME — nombre de la marca SPONSOR (cliente principal) tal como se MUESTRA al usuario:
 * la "marca" que se amplifica en los posts. Se usa en los textos de la UI ("mencionando a ___")
 * y, vía {{SPONSOR_NAME}}, en los legales (terms.html / privacy.html).
 *
 * Es una ETIQUETA de display, INDEPENDIENTE de la marca-clave del backend (`SINGLE_BRAND_ID`
 * en `shared/drupi/brand_config.py`): el clientId del backend es una CLAVE de datos (pk de
 * DynamoDB / prefijo S3) que NO se cambia sin migrar — esto es sólo el nombre visible.
 */
export const SPONSOR_NAME = requireEnv('REACT_APP_SPONSOR_NAME', process.env.REACT_APP_SPONSOR_NAME);
